
















































































import { GuildMemberViewObject, GuildViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { debounce } from 'lodash-es';
import { GuildsApi } from '@/services/api/api.guilds';
import Paginator from '@/components/paging/Paginator.vue';
import Character from '@/components/frontpage/armory/characters/Character.vue';
import GuildEventLog from '@/components/frontpage/armory/guilds/GuildEventLog.vue';
import GuildBank from '@/components/frontpage/armory/guilds/GuildBank.vue';
import { HelperMethods } from '@/core/HelperMethods';

@Component({
    components: { Paginator, Character, GuildEventLog, GuildBank }
})
export default class ArmoryGuild extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    @Prop({ required: true, type: String })
    name!: string;

    initialized: boolean = false;
    guild: GuildViewObject | null = null;
    guildLeader: boolean = false;
    guildMember: GuildMemberViewObject | null = null;

    get isGuilLeader(): boolean {
        return this.isAdmin || this.guildLeader;
    }

    get isGuildMember(): boolean {
        return this.isAdmin || !!this.guildMember;
    }

    getClassColor(classId: number) {
        return HelperMethods.GetClassColor(classId);
    }

    loading: boolean = false;

    get user() {
        return UserModule?.user;
    }

    get isAdmin() {
        return !!this.user?.IsAdmin;
    }

    get members() {
        return this.guild?.members;
    }

    guildDetailsDebounced = debounce(this.getGuildDetails, 250);
    guildMemberStatusDebounced = debounce(this.getGuildMemberStatus, 250);

    async getGuildDetails() {
        this.loading = true;
        this.guild = null;

        try {
            const result = await GuildsApi.GetGuildByName(this.realmId, this.name);
            this.guild = result.guild;
        } finally {
            this.loading = false;
            this.initialized = true;
            this.guildMemberStatusDebounced();
        }
    }

    async getGuildMemberStatus() {
        if (!this.guild) return;

        try {
            const result = await GuildsApi.GetGuildMemberStatus(this.realmId, this.guild.id);
            this.guildLeader = result?.isGuildLeader ?? false;
            this.guildMember = result?.member ?? null;
        } catch {

        } finally {
            this.loading = false;
        }
    }

    @Watch('name')
    onNameChange() {
        if (this.initialized) {
            this.guildDetailsDebounced();
        }
    }

    @Watch('realmId')
    onRealmChange() {
        if (this.initialized) {
            this.guildDetailsDebounced();
        }
    }

    @Watch('user')
    onUserChange() {
        this.guildMemberStatusDebounced();
    }

    created() {
        this.guildDetailsDebounced();
    }
}
